/**
 * Direct In-App APK & Web Auto-Update Checker
 */

export const CURRENT_APP_VERSION = '1.3.0';

export interface VersionInfo {
  version: string;
  versionCode: number;
  downloadUrl: string;
  windowsDownloadUrl?: string;
  releaseNotes: string;
  pubDate: string;
  minAndroidVersion?: string;
}

export function compareVersions(v1: string, v2: string): number {
  const parts1 = v1.split('.').map((p) => parseInt(p, 10) || 0);
  const parts2 = v2.split('.').map((p) => parseInt(p, 10) || 0);
  const maxLen = Math.max(parts1.length, parts2.length);

  for (let i = 0; i < maxLen; i++) {
    const num1 = parts1[i] || 0;
    const num2 = parts2[i] || 0;
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }
  return 0;
}

export async function checkRemoteVersion(): Promise<{ hasUpdate: boolean; info: VersionInfo | null }> {
  try {
    const versionUrl = 'https://ck-share.pages.dev/version.json?t=' + Date.now();
    const res = await fetch(versionUrl, { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const info: VersionInfo = await res.json();
    const hasUpdate = compareVersions(info.version, CURRENT_APP_VERSION) > 0;
    return { hasUpdate, info };
  } catch (err) {
    console.warn('[UpdateChecker] Failed checking remote version:', err);
    return { hasUpdate: false, info: null };
  }
}

export function triggerDirectApkDownload(downloadUrl: string = 'https://ck-share.pages.dev/downloads/ck-share-android.apk') {
  if (typeof window !== 'undefined') {
    // If inside Capacitor Android native app
    const isCapacitor =
      typeof (window as any).Capacitor !== 'undefined' &&
      typeof (window as any).Capacitor.isNativePlatform === 'function' &&
      (window as any).Capacitor.isNativePlatform();

    if (isCapacitor) {
      // Trigger download via Android browser / DownloadManager
      window.open(downloadUrl, '_system');
    } else {
      // Direct browser download
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'ck-share-android.apk';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}
